import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";
import moment from "moment-timezone";
import { DateRangePicker } from "react-dates";

import { Row } from "components/Layout";
import NTMButton from "components/Buttons/NTMButton";
import NTMSelect from "components/Buttons/NTMSelect";
import Charts from "containers/Data/Charts";

import { getDailyData, getMonthlyData, useGetSiteList } from "service/SolarsmartService";
import styles from "./_solarsmart.module.scss";


export default function SolarsmartAveragePage({ type = 'stats-solar' }) {

	let { sites } = useGetSiteList();
	const [nodeId, setNodeId] = useState();
	const [interval, setIntvl] = useState("daily");
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [focusedInput, setFocusedInput] = useState();
	const [data, setData] = useState([])
	let buttonRef = useRef();

	useEffect(() => {
		if(!nodeId && sites?.length > 0) {
			setNodeId(sites[0].device.id)
		}
		else if (startDate && endDate) {
			let start = moment(startDate).format("DD-MM-YYYY");
			let end = moment(endDate).format("DD-MM-YYYY");
			if (interval === 'monthly') {
				getMonthlyData(nodeId, start, end).then(setData)
			} else {
				getDailyData(nodeId, start, end).then(setData)
			}
		}
	}, [sites, nodeId, interval, startDate, endDate, type])

	if (sites.length === 0) return null

	return <div className="animated fadeIn">
		<Row className={styles.box}>
			<NTMSelect value={nodeId} onChange={event => setNodeId(event.target.value)}>
				{sites.map(n =>
					<option key={n.device.id} value={n.device.id}>{n.device.label ||n?.plant?.plantName || n.device.deviceId}</option>
				)}
			</NTMSelect>
			<NTMButton
				primary={interval === "daily"}
				unselected={interval !== "daily" ? 'true' : undefined}
				onClick={() => setIntvl("daily")}
			>Giorno</NTMButton>
			<NTMButton
				primary={interval === "monthly"}
				unselected={interval !== "monthly" ? 'true' : undefined}
				onClick={() => setIntvl("monthly")}
			>Mese</NTMButton>
			<div data-tip data-for='global' data-event='click' ref={buttonRef}>
				<NTMButton primary>
					{
						startDate ?
							`${moment(startDate).format("DD/MM/YYYY")} - ${moment(endDate).format("DD/MM/YYYY")}`
							:
							<>Scegli Periodo&nbsp;<i className="fa fa-caret-down" aria-hidden="true" /></>
					}
				</NTMButton>
			</div>
			<ReactTooltip
				id='global'
				aria-haspopup='true'
				effect='solid'
				place={"bottom"}
				clickable
				getContent={() => <DateRangePicker
					startDate={startDate} // momentPropTypes.momentObj or null,
					startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
					endDate={endDate} // momentPropTypes.momentObj or null,
					endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
					onDatesChange={({ startDate, endDate }) => {
						setStartDate(startDate)
						setEndDate(endDate)
						if (startDate && endDate) {
							buttonRef.current.click();
						}
					}} // PropTypes.func.isRequired,
					focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
					onFocusChange={focusedInput => setFocusedInput(focusedInput)} // PropTypes.func.isRequired,
					withPortal={true}
					startDatePlaceholderText={"Inizio"}
					endDatePlaceholderText={"Fine"}
					displayFormat={"DD/MM/YYYY"}
					isOutsideRange={(o) => o.isAfter(moment(), 'day')}
					small={true}
				/>}
			/>
		</Row>
		<div style={{ margin: "1rem auto" }}>
			<Charts data={data} type={type || 'statistics'} />
		</div>
	</div>
}
